import color from '@mui/material/colors/purple';

export default function Style(theme) {
  const style = {
    root: {
      
    },
    logo: {
      color: color[500],
      fontWeight: 700
    },
    dropdownRoot: {
      margin: 8
    },
    link: {
      margin: 8,
      display: "block",
      textDecoration: 'none'
    }
  }
    return style
}